<template>
  <div class="card">
    <h2 class="card-title">{{ title }}</h2>
    <div class="card-content">
      <div class="info-box" v-if="info">
        <p v-html="info"></p>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimuladorCard",
  props: {
    title: {
      type: String,
      required: true
    },
    info: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
.card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  border: 1px solid #eaeaea;
}

h2.card-title {
  background-color: #f0512d;
  color: white;
  padding: 15px 20px;
  font-size: 1.3em;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 10px 10px 0 0;
}

.card-content {
  padding: 25px;
  overflow: hidden;
}

.card-content::after {
  content: "";
  display: table;
  clear: both;
}

.info-box {
  background-color: #f9f9f9;
  border-left: 4px solid #f0512d;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 4px;
  width: 100%;
  clear: both;
  box-sizing: border-box;
}
</style>
